import Tracking from "@reco/service/src/Tracking";
import type { GridBox } from "@reco/shared/src/types/gridbox";
import type { Recommendation } from "@reco/shared/src/types/recommendation";
import { useElementVisibility } from "@vueuse/core";
import { useTemplateRef, watch } from "vue";

type UseShopAsstTrackingParams = {
  recommendations: Recommendation[];
  gridboxType?: string;
  creativeSlot?: string, 
};

export function useShopAsstTracking(params: UseShopAsstTrackingParams) {
  const { recommendations, gridboxType, creativeSlot } = params;
  const rootElement = useTemplateRef<HTMLElement>("root");
  const shopAsstElement = useTemplateRef<HTMLElement>("shopping-assistant");
  const isRootVisible = useElementVisibility(rootElement, { once: true });

  watch(
    () => isRootVisible.value && !!shopAsstElement.value,
    (shouldTrack) => {
      if (shouldTrack) {
        Tracking.trackShopAsstView({
          gridboxes: recommendations as unknown as GridBox[],
          gridboxType,
          creativeSlot,
        });
      }
    },
  );

  const onShopAsstCtaClick = () => {
    Tracking.trackShopAsstClick();
  };

  return {
    onShopAsstCtaClick,
  };
}
